import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { IPulsaraAttachmentImage, IPulsaraState } from '../store/pulsara.types'
import { getPulsaraSelector } from '../selectors'
import { PulsaraConstants } from '../store/pulsara.constants'
import { setPulsaraAttachments } from '../store/pulsara.actions'

export function* deletePulsaraAttachment() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)
  const pulsaraState: IPulsaraState = yield select(getPulsaraSelector)
  const { pulsaraDetails, pulsaraAttachmentToDelete } = pulsaraState

  if (!pcrId || !pulsaraAttachmentToDelete) return

  try {
    const newAttachments = pulsaraDetails.attachments?.filter((attachment: IPulsaraAttachmentImage) => {
      return attachment.id !== pulsaraAttachmentToDelete
    })
    yield put(setPulsaraAttachments(newAttachments))

    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcrDoc.pulsara?.pulsaraAttachments) {
      const newPCRAttachments = pcrDoc.pulsara.pulsaraAttachments.filter(
        (attachment: { id: number }) => attachment.id !== pulsaraAttachmentToDelete
      )

      pcrDoc.pulsara.pulsaraAttachments = newPCRAttachments
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)
    }
  } catch (e) {
    yield put(throwPcrException(e))
  }
}

export function* deletePulsaraAttachmentSaga() {
  yield takeLatest([PulsaraConstants.DELETE_PULSARA_ATTACHMENT], performWithMutexHOG, deletePulsaraAttachment)
}
